import React from "react";
import { Button } from "@material-ui/core";
import { useRecordEvent } from "src/hooks/useRecordEvent";
import { useSelector } from "react-redux";
import { userSetupQuestionsSelector } from "src/store/system/selector";
import { completeUserOnboarding } from "src/apiService/modules/users";
import { useHistory } from "react-router-dom";

const HideSetupPageButton: React.FC = () => {
  const recordEvent = useRecordEvent();
  const setupQuestions = useSelector(userSetupQuestionsSelector);
  const history = useHistory();

  const handleClick = async () => {
    history.push("/management");
    recordEvent({
      type: "feature-hide",
      feature: "setup-page",
      element: setupQuestions ? setupQuestions : "No cards were selected.",
    });
    if (setupQuestions) {
      const remaining =
        (setupQuestions.sellingPlatforms?.length || 0) +
        (setupQuestions.connectBank !== false ? 1 : 0);
      recordEvent({
        type: "feature-adoption",
        feature: "setup-skipped",
        remainingCards: remaining,
      });
    }
    await completeUserOnboarding();
  };

  return (
    <Button variant="contained" color="secondary" onClick={handleClick}>
      Hide Setup Page
    </Button>
  );
};

export default HideSetupPageButton;
